module.exports = __webpack_public_path__ + "static/media/welcome-acquire.60a28079.png";